import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from '../auth/auth.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {

  constructor(private authService: AuthService, private router: Router) {}

  async canActivate(): Promise<boolean> {
    const isAuthenticated = await this.authService.isAuthenticated().toPromise();

    if (!isAuthenticated) {
      // Chama o login do Keycloak e aguarda o resultado
      const loginSuccess = await this.authService.login();
      if (!loginSuccess) {
        this.router.navigate(['/login']);
        return false; // Não está autenticado, não prossegue
      }
    }
   
    // Verifica o papel do usuário
    const isFuncionario = this.authService.isFuncionario();    
    if (!isFuncionario) {
      this.router.navigate(['/acesso-negado']);
      return false;
    }

    return true;
  }
}